// extracted by mini-css-extract-plugin
export var compactFilters = "_fs-4";
export var detailImage = "_fs-1";
export var dropdownContainer = "_fs-2";
export var imageContainer = "_fs-0";
export var selectedCard = "_fs-3";